import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import PackagesPage from './pages/PackagesPage';
import TopicsPage from './pages/TopicsPage';
import LearnPage from './pages/LearnPage';
import ReviewPage from './pages/ReviewPage';
import LoginPage from './pages/LoginPage';
import MainLayout from './components/MainLayout';
import './main.css';
import { ThemeProvider } from './context/ThemeContext';
import CreationStudioPage from './pages/CreationStudioPage';
import ListeningPage from './pages/ListeningPage';

// Component bảo vệ các route cần đăng nhập
function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isLoading } = useAuth();
  // Nếu đang trong quá trình kiểm tra xác thực, hiển thị một màn hình chờ
  if (isLoading) {
    return <div>Loading user...</div>; // Hoặc một spinner đẹp mắt
  }

  // Nếu đã kiểm tra xong và không đăng nhập, chuyển về trang login
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  // Nếu đã đăng nhập, hiển thị nội dung
  return <>{children}</>;
}

function AppContent() {
  const { isAuthenticated } = useAuth();

  return (
    <Routes>
      <Route path="/login" element={isAuthenticated ? <Navigate to="/" /> : <LoginPage />} />
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <MainLayout>
              <Routes>
                <Route path="/" element={<PackagesPage />} />
                <Route path="/studio" element={<CreationStudioPage />} />
                <Route path="/packages/:packageId" element={<TopicsPage />} />
                <Route path="/topics/:topicId/learn" element={<LearnPage />} />
                <Route path="/topics/:topicId/review" element={<ReviewPage />} />
                <Route path="/topics/:topicId/listen" element={<ListeningPage />} />
              </Routes>
            </MainLayout>
          </ProtectedRoute>
        }
      />
    </Routes>

  );
}

function App() {
  return (
    <ThemeProvider>
      <Router>
        <AuthProvider>
          <AppContent />
        </AuthProvider>
      </Router>
    </ThemeProvider>
  );
}

export default App;

